import { createFileRoute, useRouter } from "@tanstack/react-router";

import { DocumentsPageConnector } from "@pages/documents";

export const Route = createFileRoute("/_private/documents")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  return <DocumentsPageConnector onBack={router.history.back} />;
}
